import _ from 'lodash';
import Api from '@/api';
import * as types from '../mutation-types';

const state = {
  warehouses: [],
  overseas: [],
};

const getters = {
  masterWarehouse: s => _.filter(s.warehouses, { type: 0 }),
  pickups: s => _.filter(s.warehouses, { type: 1 }),
  transportWarehouses: s => _.filter(s.warehouses, { type: 2 }),
  postOffices: s => _.filter(s.warehouses, { type: 3 }),
  postLockers: s => _.filter(s.warehouses, { type: 4 }),
  oks: s => _.filter(s.warehouses, { type: 11 }),
  cainiaoLockers: s => _.filter(s.warehouses, { type: 12 }),
};

const actions = {
  fetchWarehouse({ commit }) {
    return Api.warehouse.get().then(({ data: response }) => {
      commit(types.RECEIVE_WARAHOUSES, response.data);
    });
  },
  fetchOverseasWarehouse({ commit }) {
    return Api.warehouse.overseas().then(({ data: response }) => {
      commit(types.RECEIVE_OVERSEAS_WAREHOUSES, response.data);
    });
  },
};

/* eslint no-param-reassign: 0, no-shadow: 0 */
const mutations = {
  [types.RECEIVE_WARAHOUSES](s, data) {
    s.warehouses = [...data];
  },
  [types.RECEIVE_OVERSEAS_WAREHOUSES](s, data) {
    s.overseas = [...data];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
